module.exports = __webpack_public_path__ + "img/system.0f6f55bd.svg";